<template>
  <div class="dropShadowMd h-full pb-20">
    <GroupedMatches />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from '../appData/AppDataProperty.vue'
import LiveMatches from '../appData/LiveMatches.vue'
import UpcomingMatches from '../appData/UpcomingMatches.vue'
import GroupedMatches from './GroupedMatches.vue';

export default defineComponent({
  name: 'Matches',
  components: { AppDataProperty, GroupedMatches, LiveMatches, UpcomingMatches },
  props: {},
  data() {
    return {}
  },
  mounted() {},
  methods: {},
})
</script>
